"use client";
import { jsx as i } from "react/jsx-runtime";
import { square as t } from "../../common/styles/mixins/square.js";
import { css as p } from "@emotion/react";
import c from "@emotion/styled";
import { COLORS as s } from "../../tokens/colors/Colors.js";
import { SIZES as l } from "../../tokens/sizes/Sizes.js";
import { forwardRef as w } from "react";
const n = w(
  ({
    "aria-label": e = "Loading...",
    feColorInvert: r = !1,
    feSize: a = "md",
    ...d
  }, m) => /* @__PURE__ */ i(
    g,
    {
      ...d,
      "aria-label": e,
      "aria-live": "polite",
      "data-comp": "loader",
      feSize: a,
      ref: m,
      role: "progressbar",
      children: /* @__PURE__ */ i(
        "svg",
        {
          "aria-hidden": !0,
          enableBackground: "new 0 0 0 0",
          height: "100%",
          version: "1.1",
          viewBox: "0 0 52 52",
          width: "100%",
          x: "0px",
          xmlns: "http://www.w3.org/2000/svg",
          xmlnsXlink: "http://www.w3.org/1999/xlink",
          xmlSpace: "preserve",
          y: "0px",
          children: [
            o({ cx: 6, begin: 0.1, feColorInvert: r }),
            o({ cx: 26, begin: 0.2, feColorInvert: r }),
            o({ cx: 46, begin: 0.3, feColorInvert: r })
          ]
        }
      )
    }
  )
);
n.displayName = "Loader";
const L = n, o = ({ begin: e, cx: r, feColorInvert: a }) => /* @__PURE__ */ i(
  "circle",
  {
    fill: a ? s.white : s.brand,
    stroke: "none",
    cx: r,
    cy: "26",
    r: "6",
    children: /* @__PURE__ */ i(
      "animate",
      {
        attributeName: "opacity",
        dur: "1s",
        values: "0;1;0",
        repeatCount: "indefinite",
        begin: e
      }
    )
  },
  r
), g = c.div(
  ({ feSize: e }) => p`
		${e === "md" && t(l.s48)}
		${e === "sm" && t(l.s24)}
	`
);
export {
  L as default
};
